// extracted by mini-css-extract-plugin
export var btnWrap = "flowStepUserInfo-module--btnWrap--6f402";
export var innerWrap = "flowStepUserInfo-module--innerWrap--65841";
export var subhead = "flowStepUserInfo-module--subhead--c26ce";